import { FC } from 'react';
import { PercentageInput } from '../../UI';
import { useTranslation } from 'react-i18next';
import { RealEstateFormValues } from '../types';
import { useController, useFormContext } from 'react-hook-form';

interface RealEstateOwnershipAllocationInputProps {
  className?: string;
}

export const RealEstateOwnershipAllocationInput: FC<RealEstateOwnershipAllocationInputProps> = ({ className }) => {
  const { t: tForm } = useTranslation('form');
  const { control } = useFormContext<RealEstateFormValues>();
  const {
    field,
    formState: { errors },
  } = useController<RealEstateFormValues, 'ownershipAllocation'>({
    control,
    name: 'ownershipAllocation',
    rules: { required: true },
    defaultValue: 100,
  });

  return (
    <PercentageInput
      {...field}
      decimalsLimit={3}
      className={className}
      allowNegativeValue={false}
      placeholder={tForm('general-required-placeholder')}
      label={tForm('general-ownership-allocation-input')}
      status={errors.ownershipAllocation ? 'errored' : 'normal'}
    />
  );
};
